module.exports = __webpack_public_path__ + "img/kocht_ellwangen-md.90b39a42.jpg";